// extracted by mini-css-extract-plugin
export default {"info-table":"styles-module__info-table___Wa6eg","title":"styles-module__title___qRjdW","content":"styles-module__content___pg1_B"};